import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
    transform(value: number, decimalPlaces: number = 0, useGrouping: boolean = true): string {
      if (isNaN(value)) return '';
  
      const options: Intl.NumberFormatOptions = {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: useGrouping
      };
  
      return new Intl.NumberFormat('de-DE', options).format(value);
    }
  }